import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Dialog, DialogActions, styled, Typography } from '@mui/material';

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  zIndex: 2000,

  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
  '.MuiPaper-root': {
    minWidth: '300px',
    border: `${theme.spacing()} solid ${
      theme.palette.colors.onSecondaryAndDetailBackground
    }`,
    backgroundColor: theme.palette.colors.primaryBackground,

    [theme.breakpoints.up('sm')]: {
      minWidth: '400px',
    },
  },
}));

export const IconStyledBox = styled(Box)(() => ({
  justifyContent: 'center',
  display: 'flex',
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.colors.mainFocused,
  height: 48,

  [theme.breakpoints.down('sm')]: {
    fontSize: 24,
    color: theme.palette.colors.mainFocused,
    height: 24,
  },
}));

export const BoxTitleMessageStyled = styled(Box)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.mainFocused,
  justifyContent: 'center',
  display: 'flex',
  marginTop: theme.spacing(2),

  [theme.breakpoints.up('lg')]: {
    fontSize: '22px',
  },
}));

export const BoxDescrMessageStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textAlign: 'center',
  justifyContent: 'center',
  display: 'flex',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  fontSize: '12px',
  lineHeight: 'normal',
  letterSpacing: 'normal',

  [theme.breakpoints.up('lg')]: {
    fontSize: '14px',
  },
}));

export const DescrMessageStyled = styled(Typography)(() => ({
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  letterSpacing: 'inherit',
}));

export const DescrEmailStyled = styled(Box)(() => ({
  fontWeight: 700,
}));

export const DialogActionsStyled = styled(DialogActions)(() => ({
  justifyContent: 'center',
}));
